import React, { useEffect, useState } from "react";
import {
    faTrash,
    faArrowCircleUp,
    faArrowCircleDown,
    faPlus,
    faSave,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import templatePriorityOptionsApi, { TemplatePriorityOptionType } from "../../../utils/api/templatePriorityOptionsApi";
import { toast } from "react-toastify";

type Props = {
    templateId?: number;
    findingPriorityOptions: TemplatePriorityOptionType[];
};

const FindingPriorityOptions = (props: Props) => {

    const [options, setOptions] = useState<TemplatePriorityOptionType[]>([]);

    useEffect(()=>{
        setOptions(props.findingPriorityOptions)
    },[props.findingPriorityOptions]);

    const handleAddOption = () => {
        const newOption: TemplatePriorityOptionType = {
            label: "",
            order: options.length + 1,
            template_id: props.templateId || 1,
        };
        setOptions([...options, newOption]);
    };

    const handleRemoveOption = (index: number) => {
        const updated = [...options];
        updated.splice(index, 1);
        const reordered = updated.map((opt, idx) => ({
            ...opt,
            order: idx + 1,
        }));
        setOptions(reordered);
    };

    const handleChange = (index: number, value: string) => {
        const updated = [...options];
        updated[index].label = value;
        setOptions(updated);
    };

    const moveUp = (index: number) => {
        if (index === 0) return;
        const updated = [...options];
        [updated[index - 1], updated[index]] = [updated[index], updated[index - 1]];
        updated.forEach((opt, idx) => (opt.order = idx + 1));
        setOptions(updated);
    };

    const moveDown = (index: number) => {
        if (index === options.length - 1) return;
        const updated = [...options];
        [updated[index + 1], updated[index]] = [updated[index], updated[index + 1]];
        updated.forEach((opt, idx) => (opt.order = idx + 1));
        setOptions(updated);
    };

    const handleSaveOption = () => {
        if (props.templateId) {
            templatePriorityOptionsApi
                .update(props.templateId, options)
                .then(() => {
                    toast.success("Finding priority options have been updated successfully!");
                })
                .catch((e) => {
                    toast.error("Something went wrong while saving finding priority options!");
                    console.log(e.message);
                });
        } else {
            toast.error("Something went wrong! Template ID not found!");
        }
    };

    return (
        <>
            <div className="add-button-container">
                <button onClick={handleAddOption} className="add-button">
                    Add Option <FontAwesomeIcon className="cursor-pointer" icon={faPlus} size={"sm"} />
                </button>
                <button onClick={handleSaveOption} className="save-button">
                    Save Priority Options <FontAwesomeIcon className="cursor-pointer" icon={faSave} size={"sm"} />
                </button>
            </div>

            <div className="dynamic-form">
                {options.map((option: TemplatePriorityOptionType, index: number) => (
                    <div className="option-row" key={index}>
                        <input
                            type="text"
                            value={option.label}
                            onChange={(e) => handleChange(index, e.target.value)}
                            className="option-input"
                        />
                        <div className="actions">
                            {index !== 0 && (
                                <FontAwesomeIcon
                                    className="col-tertiary cursor-pointer dynmic-form-btn"
                                    onClick={() => moveUp(index)}
                                    icon={faArrowCircleUp}
                                    size={"sm"}
                                />
                            )}
                            {index !== options.length - 1 && (
                                <FontAwesomeIcon
                                    className="col-tertiary cursor-pointer dynmic-form-btn"
                                    onClick={() => moveDown(index)}
                                    icon={faArrowCircleDown}
                                    size={"sm"}
                                />
                            )}
                            <FontAwesomeIcon
                                className="cursor-pointer dynmic-form-btn btn-danger"
                                onClick={() => handleRemoveOption(index)}
                                icon={faTrash}
                                size={"sm"}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};

export default FindingPriorityOptions;
